import Vue from 'vue';

const ModalBus = new Vue();

export default ModalBus;



// WEBPACK FOOTER //
// ./src/event-bus/modal-bus.js